import React from 'react';
import './css/login.css';

const LoginPageFooter = () => {
    return (
        <div className="footer">
        <a href="./"><span style={{float: "left", padding: "20px", color: "white"}}>Privacy Policy</span></a>
        <span style={{float: "right", padding: "20px", color: "white"}}>&#xA9; Copyright 2021</span>
        </div>
    )
}

export default LoginPageFooter;